<template>
  <div class="tabbar-wrap">
    <div
      v-for="(item, index) in list"
      :key="index"
      class="tab-item"
      :class="{ active: current === index }"
      @click="tapItem(item)"
    >
      <img :src="item.icon" class="tab-icon" />
      <span class="tab-text">{{ item.title }}</span>
    </div>
  </div>
</template>

<script setup>
import { useNav } from "@/hooks/useNav";
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useAppStore } from "@/stores/modules/app";
import eventBus from "@/utils/eventBus";
import home from "@/assets/images/home.svg";
import slot from "@/assets/images/slot.svg";
import box from "@/assets/images/box.svg";
import wd from "@/assets/images/wd.svg";
import dop from "@/assets/images/dop.svg";

const appStore = useAppStore();
const route = useRoute();
const nav = useNav();

const current = computed(() => {
  return appStore.tabbarCur;
});

const list = ref([
  {
    title: "Beranda",
    icon: home,
    path: "/home"
  },
  {
    title: "Promosi",
    icon: slot,
    path: "/bonus"
  },
  {
    title: "Deposit",
    icon: box,
    path: "/deposit"
  },
  {
    title: "Penarikan",
    icon: wd,
    path: "/withdraw"
  },
  {
    title: "Profil",
    icon: dop,
    path: "/profile"
  }
]);

onMounted(() => {
  const index = list.value.findIndex(v => v.path === route.path);
  if (index > -1) {
    appStore.updateTabbarCur(index);
  }
});

function tapItem(item) {
  if (route.path === item.path) return;
  eventBus.emit("TapTabbarItem", item);
  nav(item.path);
}
</script>

<style lang="scss" scoped>
.tabbar-wrap {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 540px;
  height: 65px;
  background: #2b4f14;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 8px;
  z-index: 501;
  border-radius: 10px;
}

.tab-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 55px;
  margin: 5px 2px;
  cursor: pointer;
  transition: all 0.25s ease;
  color: #fff;
  border-radius: 20px;
  white-space: nowrap;
}

.tab-item.active {
  background: url('@/assets/images/masking1.svg') center/cover no-repeat;
  color: #fff;
}

.tab-icon {
  width: clamp(20px, 5vw, 24px);
  height: clamp(20px, 5vw, 24px);
  margin-bottom: 3px;
  filter: brightness(0) invert(1);
  transition: filter 0.25s ease;
}

.tab-item.active .tab-icon {
  filter: brightness(0) invert(1);
}

.tab-text {
  font-size: clamp(9px, 2.2vw, 11px);
  font-weight: 600;
  color: #fff;
  transition: color 0.25s ease;
}

.tab-item.active .tab-text {
  color: #fff;
}

.tab-item:active {
  transform: scale(0.92);
}
</style>
